<template>
  <Layout>
    <PageHeader
      :items="breadcrumbs"
    />
    <div class="container-app">
      <div class="content-title">
        <span class="title-card-app">{{ title }}</span>
        <span>
          <button
            size="sm"
            class="p-0 ml-2 btn-link-add"
            @click.prevent="openCreateUpdateModal(null, null, 'create')"
          >
            Crear
            <b-icon
              class="icon-plus"
              icon="plus-circle-fill"
            ></b-icon>
          </button>
        </span>
      </div>
      <div class="card-app">
        <div class="row">
          <div class="col-md-12 p-0 m-0">
            <BaseDatatable
              ref="table"
              :drfprovider="myProvider"
              :tableheaders="tableHeaders"
              :sortby="sortBy"
              :sortdesc="sortDesc"
            >
              <template #head(actions)>
                <span class="title-actions d-flex justify-content-center">Acciones</span>
                <div class="d-flex content-actions">
                  <span>Información</span>
                  <span>Editar</span>
                  <span>Eliminar</span>
                </div>
              </template>
              <template v-slot:cell(permission__name)="data">
                {{ data.item.permission.name }}
              </template>
              <template v-slot:cell(permission__codename)="data">
                {{ data.item.permission.codename }}
              </template>
              <template v-slot:cell(permission_type)="data">
                {{ data.item.permission_type_verbose }}
              </template>
              <template v-slot:cell(actions)="row">
                <b-button-group size="xs" class="d-flex">
                  <b-button
                    :id="`info-btn-${row.index}`"
                    variant="btn-link btn-hover text-info btn-transparent"
                    size="xs"
                    :disabled="
                      isSubmitting || actionsLoadings[`info-btn-${row.index}`]
                    "
                    @click="
                      openDetailModal(
                        row.item,
                        row.index,
                        `info-btn-${row.index}`
                      )
                    "
                  >
                    <i
                      v-if="!actionsLoadings[`info-btn-${row.index}`]"
                      class="fe-info fe-2x"
                    ></i>
                    <b-spinner
                      v-if="actionsLoadings[`info-btn-${row.index}`]"
                      small
                      label="Spinning"
                      variant="info"
                    >
                    </b-spinner>
                  </b-button>
                  <b-button
                    v-if="row.item.permission_type === 2"
                    :id="`update-btn-${row.index}`"
                    :disabled="isSubmitting"
                    variant="btn-link btn-hover text-info btn-transparent"
                    size="xs"
                    @click="
                      openCreateUpdateModal(row.item, row.index, 'update')
                    "
                  >
                    <b-icon-pencil></b-icon-pencil>
                  </b-button>

                  <b-button
                    v-if="row.item.permission_type === 2"
                    :id="`delete-btn-${row.index}`"
                    :disabled="isSubmitting"
                    variant="outline-danger btn-transparent"
                    size="xs"
                    @click="openDeleteModal(row.item, row.index)"
                  >
                    <b-icon-trash></b-icon-trash>
                  </b-button>
                </b-button-group>
              </template>
            </BaseDatatable>
          </div>
        </div>
      </div>
    </div>
    <!-- Detail modal -->
    <b-modal
      :id="detailModal.id"
      v-model="detailModalShow"
      :title="detailModal.title"
      ok-only
      ok-title="Cerrar"
      @hide="resetdetailModal"
    >
      <!-- <pre>{{ detailModal.content }}</pre> -->
      <table class="table-hover table-sm mb-0">
        <tr>
          <th style="text-align: right">Nombre</th>
          <td>{{
            _.capitalize(
              detailModal.content.permission
                ? detailModal.content.permission.name
                : ''
            )
          }}</td>
        </tr>
        <tr>
          <th style="text-align: right">Descripción</th>
          <td>{{ _.capitalize(detailModal.content.description) }}</td>
        </tr>
        <tr>
          <th style="text-align: right">Tipo</th>
          <td>{{
            _.capitalize(detailModal.content.permission_type_verbose)
          }}</td>
        </tr>
        <tr>
          <th style="text-align: right">Miembros</th>
          <td
            v-if="
              detailModal.content.permission &&
                'user_set_info' in detailModal.content.permission &&
                detailModal.content.permission.user_set_info.length
            "
          >
            <ul>
              <li
                v-for="(user, index) in detailModal.content.permission
                  .user_set_info"
                :key="index"
              >
                {{
                  user.first_name
                    ? `${user.first_name} ${user.last_name} (${user.username})`
                    : user.username
                }}
              </li>
            </ul> </td
          ><td v-else>Sin miembros</td>
        </tr>
        <tr>
          <th style="text-align: right">Grupos</th>
          <td
            v-if="
              detailModal.content.permission &&
                'group_set_info' in detailModal.content.permission &&
                detailModal.content.permission.group_set_info.length
            "
          >
            <ul class="pl-0 ml-2">
              <li
                v-for="(group, index) in detailModal.content.permission
                  .group_set_info"
                :key="index"
              >
                {{ _.capitalize(group.name) }}
              </li>
            </ul> </td
          ><td v-else>Sin grupos</td>
        </tr>
      </table>
    </b-modal>
    <!-- Create-Update modal -->
    <b-modal
      :id="createUpdateModal.id"
      v-model="createUpdateModalShow"
      :title="createUpdateModal.title"
      :size="action === 'create' ? 'sm' : 'lg'"
    >
      <PermissionsUpdateForm
        v-if="action === 'update'"
        :validator="$v.updateForm"
        :onformsubmit="onFormSubmit"
        :form="updateForm"
      >
      </PermissionsUpdateForm>
      <PermissionsCreateForm
        v-if="action === 'create'"
        :validator="$v.createForm"
        :onformsubmit="onFormSubmit"
        :form="createForm"
      >
      </PermissionsCreateForm>
      <template v-slot:modal-footer>
        <b-button
          variant="outline-primary"
          pill
          size="sm"
          class="float-right"
          @click="createUpdateModalShow = !createUpdateModalShow"
        >
          Cancelar
        </b-button>
        <b-button
          type="submit"
          form="form"
          size="sm"
          variant="primary"
          pill
          :disabled="
            action === 'create'
              ? $v.createForm.$invalid || isSubmitting
              : $v.updateForm.$invalid || isSubmitting
          "
        >
          <span v-if="!isSubmitting">
            {{ $t('submit') }}
          </span>
          <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
          </b-spinner>
        </b-button>
      </template>
    </b-modal>
    <!-- Delete modal -->
    <b-modal
      id="delete-modal"
      v-model="deleteModalShow"
      title="Borrar permiso"
      ok-title="Borrar"
      ok-variant="danger"
      @hidden="resetDeleteModal"
      @ok="deletePerm"
    >
      <p>
        Está seguro que desea borrar el permiso llamado
        {{
          toDelete ? (toDelete.permission ? toDelete.permission.name : '') : ''
        }}
        ?
      </p>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="outline-primary" pill @click="cancel">
          Cancelar
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          pill
          :disabled="isSubmitting"
          @click="ok"
        >
          <span v-if="!isSubmitting">
            {{ $t('delete') }}
          </span>
          <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
          </b-spinner>
        </b-button>
      </template>
    </b-modal>
  </Layout>
</template>
<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import BaseDatatable from '@components/base-datatable'
import { permsMethods } from '@state/helpers'
import { required, minLength } from 'vuelidate/lib/validators'
import PermissionsUpdateForm from '@views/roles_management/perms/update-form'
import PermissionsCreateForm from '@views/roles_management/perms/create-form'

export default {
  page: {
    title: 'Permisos',
    meta: [{ name: 'Gestión de permisos', content: 'Gestión de permisos' }],
  },
  components: {
    Layout,
    PageHeader,
    BaseDatatable,
    PermissionsUpdateForm,
    PermissionsCreateForm,
  },
  data() {
    return {
      title: 'Permisos',
      breadcrumbs: [
        { text: '/', path: '/home', to: { name: 'home' } },
        {
          text: 'Permisos',
          active: true,
        },
      ],
      extraButtons: [
        {
          variant: 'info',
          title: 'Crear nuevo permiso',
          label: 'Agregar',
          to: { name: 'form' },
          function: true,
          icon: 'plus-circle-fill',
        },
      ],
      sortBy: 'permission_type',
      sortDesc: false,
      tableHeaders: [
        {
          key: 'permission__name',
          label: 'Nombre',
          sortable: true,
        },
        {
          key: 'permission__codename',
          label: 'Código',
          sortable: true,
        },
        {
          key: 'description',
          label: 'Descripción',
          sortable: true,
        },
        {
          key: 'permission_type',
          label: 'Tipo',
          sortable: true,
        },
        {
          key: 'actions',
          label: 'Acciones',
        },
      ],
      createUpdateModal: {
        id: 'create-update-modal',
        title: '',
      },
      detailModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      createForm: {
        name: '',
        codename: '',
        description: '',
      },
      updateForm: {
        url: '',
        name: '',
        codename: '',
        description: '',
      },
      action: '',
      toDelete: {},
      actionsLoadings: {},
      createUpdateModalShow: false,
      detailModalShow: false,
      deleteModalShow: false,
      isSubmitting: false,
    }
  },
  validations: {
    updateForm: {
      name: {
        required,
        minLength: minLength(4),
      },
      codename: {
        required,
      },
    },
    createForm: {
      name: {
        required,
        minLength: minLength(4),
      },
      codename: {
        required,
      },
    },
  },
  methods: {
    ...permsMethods,

    myProvider(ctx) {
      const promise = this.fetchPerms(this.$table_params(ctx))
      return promise
        .then((data) => {
          return data
        })
        .catch((error) => {
          this.$axios_error_noty(error, this)
          return []
        })
    },
    openDetailModal(item, index, button) {
      let context = this
      context.isSubmitting = true
      context.actionsLoadings[button] = true
      context.detailModal.title = `Permiso: ${item.permission.name}`
      const promise = context.fetchPermsDetail(item.url)
      return promise
        .then((data) => {
          context.detailModal.content = data
          context.detailModalShow = !context.detailModalShow
          context.isSubmitting = false
          context.actionsLoadings[button] = false
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          context.isSubmitting = false
          context.actionsLoadings[button] = false
        })
    },
    resetdetailModal() {
      this.detailModal.title = ''
      this.detailModal.content = ''
    },
    resetCreateUpdateModal(action) {
      this.createUpdateModal.title = ''
      if (action === 'create') {
        this.createForm.name = ''
        this.createForm.codename = ''
        this.createForm.description = ''
        this.$v.createForm.$reset()
      } else {
        this.updateForm.url = ''
        this.updateForm.name = ''
        this.updateForm.codename = ''
        this.updateForm.description = ''
        this.$v.updateForm.$reset()
      }
    },
    openCreateUpdateModal(item, index, action) {
      this.resetCreateUpdateModal(action)
      if (action === 'create') {
        this.action = 'create'
        this.createUpdateModal.title = `Nuevo Permiso`
      } else if (action === 'update') {
        this.action = 'update'
        this.createUpdateModal.title = `Actualizar Permiso`
        this.updateForm.url = item.url
        this.updateForm.name = item.permission.name
        this.updateForm.codename = item.permission.codename
        this.updateForm.description = item.description
      }
      this.createUpdateModalShow = !this.createUpdateModalShow
    },
    onFormSubmit(evt) {
      evt.preventDefault()
      let context = this
      context.isSubmitting = true
      if (context.$v.updateForm.$anyError) {
        context.$v.updateForm.$touch()
      }
      let form =
        context.action === 'create' ? context.createForm : context.updateForm
      let completeForm = {
        url: form.url,
        permission: form,
        description: form.description,
        permission_type: 2,
      }
      const promise = context.createUpdatePerms(completeForm)
      return promise
        .then((data) => {
          if (completeForm.url) {
            context.$generate_toast(
              context,
              'success',
              'Permiso actualizado exitosamente'
            )
          } else {
            context.$generate_toast(
              context,
              'success',
              'Permiso creado exitosamente'
            )
          }
          context.createUpdateModalShow = !context.createUpdateModalShow
          context.$refs.table.refresh()
          context.isSubmitting = false
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          context.isSubmitting = false
        })
    },
    openDeleteModal(item, index) {
      this.toDelete = item
      this.deleteModalShow = !this.deleteModalShow
    },
    resetDeleteModal(item, index) {
      this.toDelete = {}
    },
    deletePerm() {
      let context = this
      context.isSubmitting = true
      const promise = context.deletePerms(context.toDelete.url)
      return promise
        .then((data) => {
          context.$generate_toast(
            context,
            'success',
            'Permiso eliminado exitosamente'
          )
          context.$refs.table.refresh()
          context.isSubmitting = false
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          context.isSubmitting = false
        })
    },
  },
}
</script>
